export { default } from './MapPlaceholder';
